import { useState } from 'react';

/**
 * Custom hook for toast notifications
 * Returns toast state and functions to show/hide toasts
 */
export const useToast = () => {
  const [toast, setToast] = useState({
    open: false,
    message: '',
    severity: 'info' // success, error, warning, info
  });

  const showToast = (message, severity = 'info') => {
    setToast({
      open: true,
      message,
      severity
    });
  };

  const showSuccess = (message) => {
    showToast(message, 'success');
  };

  const showError = (message) => {
    showToast(message, 'error');
  };

  const showWarning = (message) => {
    showToast(message, 'warning');
  };

  const showInfo = (message) => {
    showToast(message, 'info');
  };

  const hideToast = (event, reason) => {
    // Don't close on clickaway
    if (reason === 'clickaway') {
      return;
    }
    setToast((prev) => ({ ...prev, open: false }));
  };

  return {
    toast,
    showToast,
    showSuccess,
    showError,
    showWarning,
    showInfo,
    hideToast
  };
};
